<div class="container-fluid ptCustom">

    <div class="row">
      <div class="col-12 my-2">
        <div class="card shadow-sm rounded-lg">
          <div class="card-body p-4">
            <div class="row align-items-end">
              <div class="input-group mb-3 mb-xl-0">
                <input (keyup)="enterSearchTerm($event)" [(ngModel)]='searchText' type="text" class="form-control form-control-lg" placeholder="search members...">
                <button class="btn btn-lg btn-db border-lb dropdown-toggle" type="button" id="searchFilter" data-bs-toggle="dropdown" aria-expanded="false">
                  Status: {{statusSearch.display}}
                </button>
                <ul class="dropdown-menu" aria-labelledby="searchFilter">
                  <li><a *ngIf="statusSearch.value != 3" (click)="changeStatusSearch(3)" class="dropdown-item" href="javascript:void(0)">Status: All</a></li>
                  <li><a *ngIf="statusSearch.value != 1" (click)="changeStatusSearch(1)" class="dropdown-item" href="javascript:void(0)">Status: Active</a></li>
                  <li><a *ngIf="statusSearch.value != 2" (click)="changeStatusSearch(2)" class="dropdown-item" href="javascript:void(0)">Status: Deactivated</a></li>
                </ul>
                <button (click)="hitSearchBtn()" type="button" class="btn btn-lg btn-sb border-lb"><i class="fas fa-search"></i></button>
                <button (click)="clearSearch()" type="button" class="btn btn-lg btn-primary border-lb"><i class="fas fa-times"></i></button>
              </div>
              <div class="search-filters py-2">
                <!-- hide if none -->
                <ul class="filter-tags" *ngIf="keywordSearches.length > 0">
                  <li (click)="removeSearchTerm(search)" *ngFor="let search of keywordSearches" class="tag">
                    <span>{{search}}</span><span class="remove-tag"><i class="fa fa-times-circle"></i></span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-2 mb-4">
              <div class="fs-5 fst-italic">viewing {{itemStart}}-{{itemEnd}}  of {{filteredAdmin}} members</div>
              <button type="button" (click)="addAdmin()" class="btn btn-add text-strong hvr-grow"><i class="fa-solid fa-plus"></i> new admin</button>
            </div>
            <div class="card no-shadow border border-db bg-db p-2">
              <div class="">
                <table class="table table-hover align-middle m-0">
                  <thead>
                      <tr>
                          <th>
                              <a (click)="changeSortType(1)" href="javascript:void(0)" class="sort-icons">
                                  <span [ngClass]="{'active': sortType == 1}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                  <span [ngClass]="{'active': sortType == 2}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                              </a>Name
                          </th>
                          <th>
                              <a (click)="changeSortType(2)" href="javascript:void(0)" class="sort-icons">
                                  <span [ngClass]="{'active': sortType == 3}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                  <span [ngClass]="{'active': sortType == 4}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                              </a>Status
                          </th>
                          <th class="text-end">Actions</th>
                      </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let admin of memberAdmins">
                      <td>
                        <div>
                          <p class="m-0">{{admin.fullName}} <span *ngIf="admin.isActiveUser" class="fst-italic text-muted">(you)</span></p>
                          <small class="text-muted">
                            <a href="javascript:void(0);">{{admin.emailAddress}}</a>
                          </small>
                        </div>
                      </td>
                      <td>{{admin.activeString}}</td>
                      <td class="text-end">
                        <div class="dropdown">
                          <button class="btn btn-lg btn-outline-dark action-btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="far fa-ellipsis-v"></i>
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                            <li><a class="dropdown-item" (click)="editAdmin(admin)" href="javascript:void(0)"><i class="fa-light fa-pencil fa-fw"></i> Edit User</a></li>
                            <li><a class="dropdown-item" (click)="resetPassword(admin.contactId)" href="javascript:void(0)"><i class="fa-light fa-key fa-fw"></i> Send Password Reset</a></li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-4">
              <nav aria-label="table navigation" class="d-flex align-items-center justify-content-center">
                <ngb-pagination class="pagination mb-0" [maxSize]="5" [ellipses]="true"
                                [collectionSize]="filteredAdmin"
                                [(page)]="currentPageNum" [pageSize]="itemsPerPage">
                </ngb-pagination>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
  